/**
 * @generated SignedSource<<5a09a8bafd0f0986741b44b0b326104b>>
 * @relayHash 62839dc9a36eb801c9e817f5ebefa91f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAnalyticsCommentContentType = "database" | "page" | "whiteboard" | "%future added value";
export type useViewedCommentsQuery$variables = {
  contentId: string;
  contentType: ConfluenceAnalyticsCommentContentType;
};
export type useViewedCommentsQuery$data = {
  readonly contentAnalyticsViewedComments: {
    readonly commentIds: ReadonlyArray<string | null>;
  } | null;
};
export type useViewedCommentsQuery = {
  response: useViewedCommentsQuery$data;
  variables: useViewedCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "ViewedComments",
    "kind": "LinkedField",
    "name": "contentAnalyticsViewedComments",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "commentIds"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useViewedCommentsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useViewedCommentsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "62839dc9a36eb801c9e817f5ebefa91f",
    "id": "525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65",
    "metadata": {},
    "name": "useViewedCommentsQuery",
    "operationKind": "query",
    "text": "query useViewedCommentsQuery($contentId:ID!,$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId,contentType:$contentType){commentIds}}"
  }
};
})();

(node as any).hash = "3584bbc92d39d1aa58e2ff1c3396ad40";

export default node;
